export default __webpack_public_path__ + "static/media/nflStaff7.d149dae1.jpg";